export enum PaymentTypeEnum {
  PackageSale = 1,
  ManuelSale = 2,
}
